import { Box } from '@mui/system';
import React, { useCallback, useMemo } from 'react';
import { QuickFilter } from '../../../../components/filtering/QuickFilterItem';
import QuickFilterList from '../../../../components/filtering/QuickFilterList';
import { FILTER_IDENTIFIERS } from '../../../../constants/constants';
import { useI18n } from '../../../../i18n/I18n';
import { Icons } from '../../../../icons/Icons';

type NotesTagsFilterProps = {
    availableTags: string[];
    selectedTags: string[];
    onChange: (tags: string[]) => void;
};

export default function NotesTagsFilter({ availableTags, selectedTags, onChange }: NotesTagsFilterProps) {
    const t = useI18n();

    const filters: QuickFilter[] = useMemo(
        () => [
            {
                id: FILTER_IDENTIFIERS.labels,
                label: t('common.label.tags'),
                options: availableTags,
                values: selectedTags,
                icon: Icons.LabelOutlined
            }
        ],
        [availableTags, selectedTags, t]
    );

    const onFilterChanged = useCallback((filter: QuickFilter) => onChange(filter.values), [onChange]);

    if (!availableTags.length) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                alignSelf: 'stretch',
                mt: '4px',
                mb: '8px',
                '& .MuiButtonGroup-root': { height: '100%' },
                '& .MuiButtonGroup-grouped': { borderRadius: 0.8 }
            }}
        >
            <QuickFilterList filters={filters} onFilterChanged={onFilterChanged} />
        </Box>
    );
}
